export const WLSettingFields = {
    WL_PARTNER_DISCOUNT_PERCENTAGE: 'wl_partner_discount_percentage',
    AP_MARGIN_PERCENTAGE: 'ap_margin_percentage',
    MAXIMUM_MARGIN_PERCENTAGE: 'maximum_margin_percentage',
    SERVICE_CHARGE_PERCENTAGE: 'service_charge_percentage',
};
